// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"styles_spinnerContainer__xjlZ1"};